import { render } from "./Footer.vue?vue&type=template&id=62b95d7b&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=62b95d7b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-62b95d7b"

export default script